"use strict";
/* eslint-disable */
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
var _default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M12.735 14.127a1.044 1.044 0 0 1-1.473 0l-8.07-8.072a.418.418 0 0 1 .234-.707c.08-.012.16-.018.24-.018h16.667c.08 0 .161.006.24.018a.417.417 0 0 1 .235.707l-8.073 8.072Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.574 12.056 5.167-5.167a.15.15 0 0 1 .166-.032.15.15 0 0 1 .093.14v10c0 .92-.746 1.667-1.667 1.667H3.667c-.92 0-1.667-.747-1.667-1.667v-10c0-.06.038-.115.093-.138a.15.15 0 0 1 .167.032l5.168 5.167a.21.21 0 0 1 0 .295l-3.203 3.202a.624.624 0 0 0 .883.884l3.202-3.202a.21.21 0 0 1 .295 0l1.776 1.772a2.293 2.293 0 0 0 3.24 0l1.775-1.775c.08-.08.212-.08.294.001l3.202 3.203a.324.324 0 0 0 .016.016.625.625 0 0 0 .869-.9l-3.203-3.203a.208.208 0 0 1 0-.295Z"
})), "0 0 24 24", "Email");
exports.default = _default;